import http from './httpService';

const adminBase = `/admin/settings`;
const templatesBase = `/admin/email-templates`;
const publicBase = `/public`;

export async function getAdminSettings() {
  const { data } = await http.get(adminBase);
  return data;
}

export async function updateSetting(scope, key, value) {
  const { data } = await http.put(`${adminBase}/${scope}/${encodeURIComponent(key)}`, { value });
  return data;
}

export async function resetSetting(scope, key) {
  const { data } = await http.post(`${adminBase}/${scope}/${encodeURIComponent(key)}/reset`);
  return data;
}

export async function uploadAsset(assetKey, file) {
  const form = new FormData();
  form.append('asset_key', assetKey);
  form.append('file', file);
  const { data } = await http.post(`${adminBase}/assets`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function deleteAsset(assetKey) {
  const { data } = await http.delete(`${adminBase}/assets/${assetKey}`);
  return data;
}

export async function testSmtp(to) {
  const { data } = await http.post(`${adminBase}/test/smtp`, { to });
  return data;
}

export async function testPaystack() {
  const { data } = await http.post(`${adminBase}/test/paystack`);
  return data;
}

export async function getBootstrap() {
  const { data } = await http.get(`${publicBase}/bootstrap`);
  return data;
}

export async function getEmailTemplates() {
  const { data } = await http.get(templatesBase);
  return data;
}

export async function getEmailTemplate(templateKey) {
  const { data } = await http.get(`${templatesBase}/${templateKey}`);
  return data;
}

export async function updateEmailTemplate(templateKey, payload) {
  const { data } = await http.put(`${templatesBase}/${templateKey}`, payload);
  return data;
}

export async function previewEmailTemplate(templateKey, sampleData) {
  const { data } = await http.post(`${templatesBase}/${templateKey}/preview`, { data: sampleData });
  return data;
}

export async function testSendEmailTemplate(templateKey, to, sampleData) {
  const { data } = await http.post(`${templatesBase}/${templateKey}/test-send`, { to, data: sampleData });
  return data;
}

export async function resetEmailTemplate(templateKey) {
  const { data } = await http.post(`${templatesBase}/${templateKey}/reset`);
  return data;
}

export async function getPermissions() {
  const { data } = await http.get(`/auth/permissions`);
  return data;
}
